import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e8f240dc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\project_nav_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8f240dc')) {
      api.createRecord('e8f240dc', component.options)
    } else {
      api.reload('e8f240dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e8f240dc&", function () {
      api.rerender('e8f240dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-icon-svg/index.vue"
export default component.exports